import { LANGUAGE_OPTIONS, NOT_SET_OPTION } from "@contract/standards/selectOptions";
import { Select, TagsInput, Textarea } from "@mantine/core";
import { ToggleRow } from "../../ui/fields";
import { SectionCard } from "../../ui/SectionCard";
import { sectionAllowed, withSectionAllowed } from "../standardsModel";
import { LabelsFields, shown, stored } from "./LabelsFields";
import { allowLabel, type SectionProps } from "./sectionProps";

/**
 * Brand Configuration → Language & Labels (Figma 15185:541): Language (purpose and audience,
 * banned words, language variant) and Labels (currency and how it's written, calendar year,
 * fiscal year and its end month). "Other label rules" isn't shown (Dan 2026-10-02); a stored
 * value stays and the Labels switch covers it. Closed selects with Not set first (standards
 * selects spec §6).
 */
export function LanguageLabelsTab({ draft, patch, canEdit, showAllowToggles }: SectionProps) {
  const readOnly = !canEdit;
  return (
    <>
      <SectionCard title="Language">
        {showAllowToggles ? (
          <ToggleRow
            label={allowLabel("language")}
            checked={sectionAllowed(draft, "language")}
            disabled={readOnly}
            onChange={(on) => patch(withSectionAllowed(draft, "language", on))}
          />
        ) : null}
        <Textarea
          label="Purpose & Audience"
          placeholder="Monthly updates for a non-technical Board"
          rows={2}
          maxLength={300}
          value={draft.audiencePurpose}
          readOnly={readOnly}
          onChange={(e) => patch({ audiencePurpose: e.currentTarget.value })}
        />
        <TagsInput
          label="Banned Words"
          placeholder={readOnly ? undefined : "Type a word, then press Enter"}
          value={draft.bannedWords}
          onChange={(words) => patch({ bannedWords: words })}
          maxTags={30}
          readOnly={readOnly}
          clearable={!readOnly}
        />
        <Select
          label="Language Variant"
          data={[NOT_SET_OPTION].concat(LANGUAGE_OPTIONS)}
          value={shown(draft.languageVariant)}
          onChange={(v) => patch({ languageVariant: stored(v) })}
          allowDeselect={false}
          readOnly={readOnly}
        />
      </SectionCard>

      <SectionCard title="Labels">
        {showAllowToggles ? (
          <ToggleRow
            label={allowLabel("label")}
            checked={sectionAllowed(draft, "labels")}
            disabled={readOnly}
            onChange={(on) => patch(withSectionAllowed(draft, "labels", on))}
          />
        ) : null}
        <LabelsFields draft={draft} patch={patch} readOnly={readOnly} />
      </SectionCard>
    </>
  );
}
